<template>
  <div class="belong-plate">
    <MoreTitle title="所属板块" />
    <div class="grid-wrapper edge-padding">
      <div v-for="(item, index) in plates" :key="index" class="grid-item" @click="goPlate(item)">
        <p class="plate-name">{{ item.name }}</p>
        <p class="plate-rate" :style="{ color: $digitjs(item.changeRate).color() }">
          {{ $digitjs(item.changeRate).unit('%').rounded() }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      plates: []
    }
  },
  computed: {
    market() {
      return this.$funs.getMarket(this.$route.query.symbol)
    },
    symbol() {
      return this.$route.query.symbol
    }
  },
  created() {
    this.getPlates()
  },
  methods: {
    async getPlates() {
      let symbols = [this.symbol]
      if (this.market === 'us') {
        const relates = await this.getRelatesInfo()
        symbols = relates.map((item) => `HY${item.industry}.us`)
      }
      const plates = await this.getQuote([...new Set(symbols)])

      this.plates = plates
    },
    async getRelatesInfo() {
      const res = await this.$post(this.$api.f10.us + '/summary/relates-info', {
        symbol: this.symbol
      })
      return res.data ?? []
    },
    async getQuote(symbols) {
      if (!symbols?.length) {
        return []
      }

      let res = []

      if (this.market === 'jp') {
        res = await this.$post(
          this.$api.sdk.jp + '/industry/quote',
          {
            stockCode: symbols[0],
            timeMode: 0
          },
          {
            headers: {
              'Org-Data-Enable': 'false'
            }
          }
        )
      }
      if (this.market === 'us') {
        const url = this.$api.rm.us + '/index/quote/belong'
        res = await this.$post(
          url,
          {
            symbols,
            timeMode: 0
          },
          {
            headers: {
              'Org-Data-Enable': 'false'
            }
          }
        )
      }

      return res.body ?? res.data ?? []
    },
    goPlate({ symbol, name }) {
      const message = JSON.stringify({
        from: '',
        dest: 'plate',
        params: { symbol, name },
        describe: '需要根据参数跳转至板块榜单。'
      })
      window.parent.postMessage(message, '*')
    }
  }
}
</script>

<style lang="scss" scoped>
.belong-plate {
  background: var(--bg-color-2);
  .grid-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
  }
  .grid-item {
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    background: var(--bg-color-3);
  }
  .plate-name {
    margin-bottom: 6px;
  }
}
</style>
